import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export enum AnimationState {
    In = 'in',
    Out = 'out'
}

type HintProps = {
    showHint: boolean;
} & { children: React.ReactNode };

export function Hint({ showHint, children }: HintProps) {
    return (
        <Box data-state={showHint ? AnimationState.In : AnimationState.Out}>
            <Typography
                variant="body1"
                sx={{
                    fontSize: '1.6rem',
                    fontFamily: 'Gilroy',
                    color: 'text.secondary'
                }}
            >
                {children}
            </Typography>
        </Box>
    );
}
